import React from 'react';
import './Storage.css';

function StorageBar({ storage, compact = false }) {
  if (!storage) return null;

  const { used_formatted, limit_formatted, percentage } = storage;

  // Determine color based on usage
  let barClass = 'storage-bar-fill';
  if (percentage >= 90) {
    barClass += ' critical';
  } else if (percentage >= 75) {
    barClass += ' warning';
  }

  if (compact) {
    return (
      <div className="storage-compact">
        <span className="storage-text">
          {used_formatted} / {limit_formatted}
        </span>
        <div className="storage-bar-mini">
          <div className={barClass} style={{ width: `${percentage}%` }} />
        </div>
      </div>
    );
  }

  return (
    <div className="storage-container">
      <div className="storage-header">
        <span className="storage-label">Storage Used</span>
        <span className="storage-text">
          {used_formatted} of {limit_formatted} ({percentage}%)
        </span>
      </div>
      <div className="storage-bar">
        <div className={barClass} style={{ width: `${percentage}%` }} />
      </div>
      {percentage >= 90 && (
        <p className="storage-warning">
          Storage almost full. Delete some files to upload more.
        </p>
      )}
      {percentage >= 75 && percentage < 90 && (
        <p className="storage-notice">
          Storage getting low. Consider deleting old files.
        </p>
      )}
    </div>
  );
}

export default StorageBar;
